import { Component, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, RouterLink } from '@angular/router';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { take } from 'rxjs';
import { AuthService } from '../../core/auth/auth.service';
import { resolveBrowserLanguage } from '../../core/i18n/browser-language';
import { NEW_CHAT_ID } from '../../core/models/api.models';
import { ChatApiService } from '../chat/services/chat-api.service';

@Component({
  selector: 'app-login-page',
  standalone: true,
  imports: [RouterLink, TranslocoPipe],
  template: `<main class="login-page"><a routerLink="/" class="login-brand"><span class="brand-mark"><i></i><i></i><i></i></span>TAI</a><section><p>TEADIT ARTIFICIAL INTELLIGENCE</p><h1>{{ 'login.title' | transloco }}<br><span>{{ 'login.titleAccent' | transloco }}</span></h1><p class="login-copy">{{ 'login.description' | transloco }}</p><button type="button" (click)="continue()">{{ 'login.continueMicrosoft' | transloco }} <span>↗</span></button></section></main>`,
})
export class LoginPage {
  private readonly auth = inject(AuthService); private readonly api = inject(ChatApiService); private readonly router = inject(Router);
  private readonly i18n = inject(TranslocoService); private readonly pageTitle = inject(Title);
  constructor() {
    const language = resolveBrowserLanguage(navigator.language);
    this.i18n.setActiveLang(language);
    document.documentElement.lang = language === 'pt' ? 'pt-BR' : language;
    this.i18n.selectTranslate('login.meta.title', {}, language).pipe(take(1)).subscribe(title => this.pageTitle.setTitle(title));
    if (this.auth.isAuthenticated()) this.openInitialChat();
  }
  protected continue(): void { this.auth.login(); }
  private openInitialChat(): void { this.api.list().subscribe({ next: result => void this.router.navigate(['/chat', result.value?.[0]?.id ?? NEW_CHAT_ID]), error: () => void this.router.navigate(['/chat', NEW_CHAT_ID]) }); }
}
